import React from 'react'
import CardUI from '../../widgets/layout/CardUI'
import MessageUI from '../../widgets/output/MessageUI'
import './PasswordExternal.css'

const PasswordExternalUI = ({context, messageList, identityProvider, onCancel}) =>
  <CardUI context={context} className='usr_pwd_ext'>
    <div className='g_flex_h'>
      {
        identityProvider === 'facebook' &&
        <MessageUI messageList={messageList} messageKey='c_fb_user_passwd' args={[context.session.appName]} />
      }
      {
        identityProvider === 'google' &&
        <MessageUI messageList={messageList} messageKey='c_g_user_passwd' args={[context.session.appName]} />
      }
      <div className="icon icon-times g_link" onClick={onCancel}></div>
    </div>
  </CardUI>

export default PasswordExternalUI
